<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div>营期期限</div>
                </div>

                <div class="admin_main_block_right">
                    <div><el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button></div>
                </div>
            </div>

            <div class="admin_form_main">
                <el-form  label-width="100px" ref="info" :model="info">
                    <el-form-item label="相册" prop="F_IN_KECSC_ID">
                        <el-select v-model="info.F_IN_XIANGCSC_ID" placeholder="请选择相册" @change="selectChange()">
                            <el-option label="请选择相册" :value="0"></el-option>
                            <el-option v-for="(v,k) in list['xiangcsc']" :label="v.F_VR_JIANJ" :key="k" :value="v.F_IN_ID"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="评价人" prop="F_IN_YONGHGZH_ID">
                        <el-select v-model="info.F_IN_YONGHGZH_ID" placeholder="请选择公众号" @change="selectChange()">
                            <el-option label="请选择公众号" :value="0"></el-option>
                            <el-option v-for="(v,k) in list['gongzh']" :label="v.nickname" :key="k" :value="v.F_IN_ID"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="评价星级" prop="F_IN_PINGJXJ">
                        <el-select v-model="info.F_IN_PINGJXJ" placeholder="选择评价星级">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="五星" value="5"></el-option>
                            <el-option label="四星" value="4"></el-option>
                            <el-option label="三星" value="3"></el-option>
                            <el-option label="二星" value="2"></el-option>
                            <el-option label="一星" value="1"></el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item label="内容" class="width_auto_70">
                        <wangeditor @goods_content="goods_content" :contents="info.F_VR_PINGJNR"></wangeditor>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('info')">提交</el-button>
                        <!-- <el-button @click="resetForm('info')">重置</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import wangeditor from "@/components/seller/wangeditor.vue"
    export default {
        components: {
            wangeditor,
        },
        props: {},
        data() {
            return {
                edit_id:0,
                info:{
                    F_VR_PINGJNR:''
                },
                list:[],
                upload_headers:{},
            };
        },
        watch: {},
        computed: {},
        methods: {
            resetForm:function(e){
                this.$refs[e].resetFields();
            },
            submitForm:function(e){
                let _this = this;

                // 验证表单
                this.$refs[e].validate(function(res){
                    if(res){
                        //  判断是Add 或者 Edit
                        let url = _this.$api.addXiangcscpj;
                        if(_this.edit_id>0){
                            url = _this.$api.editXiangcscpj+_this.edit_id;
                        }
                        // Http 请求
                        _this.$post(url,_this.info).then(function(res){
                            if(res.code == 200){
                                _this.$message.success("编辑成功");
                                _this.$router.go(-1);
                            }else{
                                _this.$message.error("编辑失败");
                            }
                        });
                    }
                });
            },
            get_adv_info:function(){
                let _this = this;
                this.$get(this.$api.editXiangcscpj+this.edit_id).then(function(res){
                    _this.info = res.data.info;
                    _this.list = res.data;

                })

            },
            get_adv_list:function(){
                let _this = this;
                this.$get(this.$api.addXiangcscpj).then(function(res){
                    _this.list = res.data;
                })

            },
            selectChange:function(){
                this.$forceUpdate();
            },
            handleAvatarSuccess(res) {
                this.info.F_VR_FENGMIAN = res.data;
                this.$forceUpdate();
            },
            // 富文本编辑内容变化
            goods_content:function(data){
                this.info.F_VR_PINGJNR = data;
            },
        },
        created() {
            this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到

            if(!this.$isEmpty(this.$route.params.adv_position_id)){
                this.info.ap_id = this.$route.params.adv_position_id;
            }

            // 判断是否是编辑
            if(!this.$isEmpty(this.$route.params.id)){
                this.edit_id = this.$route.params.id;
            }

            if(this.edit_id>0){
                this.get_adv_info();
            }else{
                this.get_adv_list();
            }

        },
        mounted() {}
    };
</script>
<style lang="scss" scoped>
    .line{text-align: center}
</style>